import { useState } from "react";
import validator from "validator";
import { useNavigate } from "react-router-dom";
import ArrowBack from "@mui/icons-material/ArrowBack";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { useAlert } from "../../../context/AlertContext";
import "../Login/login.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showAlert } = useAlert();

  const emailValid = validator.isEmail(email);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError("");
  };

  const handleBlur = () => {
    if (email && !validator.isEmail(email)) {
      setEmailError("Unesite ispravnu email adresu");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailValid) {
      setEmailError("Unesite ispravnu email adresu");
      return;
    }

    setEmailError("");
    setLoading(true);

    try {
      await ApiMethods.post("auth/client/forgot-password/send-mail", {
        email,
      });
      navigate("/check-email", { state: { email } });
    } catch (error) {
      setEmailError("Nalog sa ovom email adresom ne postoji");
      showAlert("Greška pri slanju emaila", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hf-login-root">
      <div className="hf-login-shell">
        <div className="hf-login-brand">
          <img
            className="hf-login-brand-logo"
            src="/img/hitfitlogo.jpg"
            alt="HitFit"
          />
          <h2 className="hf-login-brand-heading">
            Vođeni treninzi za rekreativce
          </h2>
        </div>

        <div className="hf-login-card">
          <div className="hf-login-card-inner">
            <div className="hf-login-logo-wrap">
              <img
                className="hf-login-logo"
                src="/img/hitfitlogo.jpg"
                alt="HitFit"
              />
            </div>

            <button
              type="button"
              className="hf-login-back"
              aria-label="Nazad na prijavu"
              onClick={() => navigate("/login")}
            >
              <ArrowBack fontSize="small" />
            </button>

            <h1 className="hf-login-title">Zaboravljena lozinka</h1>
            <p className="hf-login-subtitle">
              Unesite svoju email adresu i poslaćemo vam link za resetovanje
              lozinke.
            </p>

            <form className="hf-login-form" onSubmit={handleSubmit}>
              <div className="hf-login-field">
                <label className="hf-login-label" htmlFor="fp-email">
                  Email adresa
                </label>
                <div
                  className={`hf-login-input-wrap${emailError ? " hf-login-input-error" : ""}`}
                >
                  <span className="hf-login-input-icon">
                    <MailOutlineIcon fontSize="small" />
                  </span>
                  <input
                    id="fp-email"
                    name="fp-email"
                    type="email"
                    inputMode="email"
                    autoComplete="email"
                    placeholder="vas@email.com"
                    value={email}
                    onChange={handleEmailChange}
                    onBlur={handleBlur}
                    required
                  />
                </div>
                {emailError ? (
                  <p className="hf-login-error-text">{emailError}</p>
                ) : (
                  <p className="hf-login-hint">
                    Unesite email adresu povezanu sa vašim nalogom.
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="hf-login-submit"
                disabled={!emailValid || loading}
              >
                {loading ? "Slanje..." : "Pošalji link za resetovanje"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
